import {type ISavedCart} from '../schema';

export const savedCartIsEmpty = (
	savedCart?: Pick<ISavedCart, 'contentCount'>,
) => !savedCart?.contentCount;

export default savedCartIsEmpty;
